import Cookies from "js-cookie";
import { send } from "@utils/fetch";

type ActionSource = "website" | "email";
type ContentCategory = "recurring";
type ContentType = "product";
type DataProcessingOption = "LDU";

interface FBCapiUserData {
  external_id: string;
  email: string;
}

interface FBCapiCustomData {
  content_category: ContentCategory;
  content_ids: string;
  content_type: ContentType;
  value: number;
  currency: string;
  order_id: string;
  custom_properties: Record<string, any>;
}

interface FBCapiEventData {
  event_id: string;
  event_name: string;
  event_source_url: string;
  pixel_id: string;
  action_source: ActionSource;
  user_data: FBCapiUserData;
  custom_data: FBCapiCustomData;

  data_processing_options?: DataProcessingOption;
  data_processing_options_country?: number;
  data_processing_options_state?: number;
  opt_out?: boolean;
}

export function fireFacebookCapi(pixelId: string, eventName: string, payload) {
  const userData: FBCapiUserData = {
    external_id: payload.external_id,
    email: payload.email,
  };

  const customData: FBCapiCustomData = {
    content_category: payload.content_category,
    content_ids: payload.content_ids,
    content_type: payload.content_type,
    value: payload.value,
    currency: payload.currency,
    order_id: payload.order_id,
    custom_properties: payload.custom_properties,
  };

  const eventData: FBCapiEventData = {
    event_id: payload.eventId,
    event_name: eventName,
    event_source_url: window.location.href,
    action_source: "website",
    user_data: userData,
    custom_data: customData,
    pixel_id: pixelId,
  };

  if (Cookies.get("ccpaOptOut")) {
    Object.assign(eventData, {
      data_processing_options: ["LDU"],
      data_processing_options_country: 1,
      data_processing_options_state: 1000,
      opt_out: true,
    });
  }

  return send("POST", `/pixel/v1/i/facebookCapiPixel/`, eventData);
}
